import cx from 'classnames';
import { AlloyButton, ErrorIcon } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { updateErrorItems } from '../../../../../../store/orders/actions';
import toastStyles from './toasts.module.scss';
import {
  getUpdateGAItem,
  getAddAndRemoveCartEvents
} from '../OrderItemsTable/utils';
import useAnalytics from '../../../../../../hooks/useAnalytics';
import { LIST_PCC_CART_PAGE } from '../../../../../../constants/analyticsConstants';
import { CSR_TEXTS } from '@app/components/pages/csr-landing/texts';

const ErrorToast = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const storeName = useSelector(s => s.store?.name) || '';
  const isBuyOnBehalf = useSelector(s => s.common?.isBuyOnBehalf) || false;
  const dealerStore = useSelector(s => s.common?.storeLocationName) ?? '';
  const { fireRemoveFromCartEvent, fireProductClickEvent, fireAddToCartEvent } =
    useAnalytics();

  const trackUpdateGA = updatedItems => {
    const { addToCartItems, removeFromCartItems } = getAddAndRemoveCartEvents(
      updatedItems,
      storeName
    );
    if (addToCartItems.length) {
      fireProductClickEvent({
        list: LIST_PCC_CART_PAGE,
        products: addToCartItems,
        dealerStore
      });
      fireAddToCartEvent({ products: addToCartItems });
    }

    if (removeFromCartItems.length) {
      fireProductClickEvent({
        list: LIST_PCC_CART_PAGE,
        products: removeFromCartItems
      });
      fireRemoveFromCartEvent({ products: removeFromCartItems, dealerStore });
    }
  };

  const trackDeleteGA = items => {
    const gaItems = items.map(item =>
      getUpdateGAItem(item, item.quantity, storeName)
    );
    fireProductClickEvent({ list: LIST_PCC_CART_PAGE, products: gaItems });
    fireRemoveFromCartEvent({ products: gaItems, dealerStore });
  };

  const updateClick = () => {
    dispatch(updateErrorItems(trackUpdateGA, trackDeleteGA));
  };
  return (
    <div
      className={cx('d-flex', {
        'mt-0': isBuyOnBehalf
      })}
    >
      <div className={`${toastStyles['toast__container-error-icon']} m-1`}>
        <ErrorIcon />
      </div>
      <div className={`m-1 ms-2`}>
        <div className={toastStyles['error-toast-text']}>
          {isBuyOnBehalf
            ? CSR_TEXTS.CSR_CART_ERROR_TOAST
            : t('USER_CART_ERROR_TOAST')}
        </div>
        {!isBuyOnBehalf && (
          <div>
            <AlloyButton
              className="ps-0"
              buttonType="ghost"
              size="small"
              onClick={updateClick}
            >
              {t('UPDATE_CART')}
            </AlloyButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorToast;
